import React, { useState, useEffect, useRef } from "react";
import ReportCount from "../reports/ReportCount";
import FunnelTrackedMetrics from "../reports/FunnelTrackedMetrics";

const ProductVariantReport = (props) => {
  const element = props.element;
  const product = props.product;
  const product_variant = props.product_variant;
  const idPrefix = props.reportIdPrefix || "";

  return (
    <React.Fragment>
      <div
        className="row hard-center element-selection-report field-option-report"
        data-product-id={product.id}
        data-report-id-prefix={idPrefix}
      >
        <div
          className="element-selection-report-bar"
          style={{ width: undefined, display: "none" }}
        ></div>
        <div className="row hard-center funnel-breakdown-item-row">
          <div className="col-xs-4 funnel-breakdown-question-label">
            <div
              className="text-xl"
              style={{
                marginBottom: "5px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {product_variant.position != null && (
                <span
                  className="funnel-breakdown-question-position"
                  style={{ flexShrink: 0 }}
                >
                  {product_variant.position}
                </span>
              )}
              <span
                className="ellipsis funnel-breakdown-question-text"
                style={{ minWidth: 0 }}
              >
                {product_variant.position != null ? " - " : ""}
                {product.title
                  ? product.title
                  : `Product ${product.position || product.id}`}
                {" - "}
                {product_variant.title
                  ? product_variant.title
                  : `Product Variant ${
                      product_variant.position
                        ? product_variant.position
                        : product_variant.id
                    }`}
              </span>
            </div>
          </div>
          <div className="col-xs-8 right">
            <p className="light text-xl" style={{ marginBottom: "10px" }}>
              <strong>
                <ReportCount
                  inline={true}
                  id={`${idPrefix}product-variant-report-${product_variant.id}`}
                  path={`/websites/${props.cta.website_id}/events_reports`}
                  payload={{
                    report_type: "distinct_count",
                    report: {
                      website_id: props.cta.website_id,
                      event_type: "Complete",
                      contactable_type: "Cta",
                      contactable_id: props.cta.id,
                      variant_id: props.step.variant_id,
                      step_id: props.step.id,
                      element_id: element.id,
                      product_id: product.id,
                      product_variant_id: product_variant.id,
                      range_start: props.range_start,
                      range_end: props.range_end,
                      broadcast_id: null,
                    },
                  }}
                  callback={() => {
                    props.calculateSelectionRates();
                  }}
                />
              </strong>{" "}
              selected (<span className="conversion-rate">0.00</span>
              %)
              <FunnelTrackedMetrics
                layout="details"
                idBase={`${idPrefix}product-variant-${product_variant.id}`}
                selectionsId={`${idPrefix}product-variant-report-${product_variant.id}`}
                path={`/websites/${props.cta.website_id}/events_reports`}
                currency={props.currency}
                gateReports={props.gateReports}
                reportingGoals={props.reportingGoals}
                report={{
                  website_id: props.cta.website_id,
                  contactable_type: "Cta",
                  contactable_id: props.cta.id,
                  variant_id: props.step.variant_id,
                  step_id: props.step.id,
                  element_id: element.id,
                  range_start: props.range_start,
                  range_end: props.range_end,
                  field: null,
                  value: null,
                  product_id: product.id,
                  product_variant_id: product_variant.id,
                  broadcast_id: null,
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductVariantReport;
